var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoreLine = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 18,
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.875 7.875C3.25625 7.875 2.75 8.38125 2.75 9C2.75 9.61875 3.25625 10.125 3.875 10.125C4.49375 10.125 5 9.61875 5 9C5 8.38125 4.49375 7.875 3.875 7.875ZM15.125 7.875C14.5063 7.875 14 8.38125 14 9C14 9.61875 14.5063 10.125 15.125 10.125C15.7437 10.125 16.25 9.61875 16.25 9C16.25 8.38125 15.7437 7.875 15.125 7.875ZM9.5 7.875C8.88125 7.875 8.375 8.38125 8.375 9C8.375 9.61875 8.88125 10.125 9.5 10.125C10.1188 10.125 10.625 9.61875 10.625 9C10.625 8.38125 10.1188 7.875 9.5 7.875Z",
  fill: "#1E1F2F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoreLine);
export { ForwardRef as ReactComponent };